import { ROLES } from "../constants/roles";
import { STATUS } from "../constants/status";

export const checkPermission = (
  userRole,
  iouStatus,
  isCreator,
  action,
  departmentApprove,
  directorApprove,
  accountApprove,
) => {
  const permissions = {
    [STATUS.CREATED]: {
      user: {
        view: (creator) => creator,
        update: (creator) => creator,
        reject: () => false,
        request: (creator) => creator,
        approve: () => false,
        viewAmountDetails: (creator) => creator,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => true,
      },
      [ROLES.DIRECTOR]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => true,
      },
      // F/A (Commercial Banking) permissions
      [ROLES.COMMERCIAL_BANKING]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => false,
      },
    },
    [STATUS.REQUESTED_BY_USER]: {
      user: {
        view: (creator) => creator,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: (creator) => creator,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => true,
        reject: () => true,
        request: () => false,
        approve: () => true,
        viewAmountDetails: () => true,
      },
      [ROLES.DIRECTOR]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => true,
      },
      // F/A (Commercial Banking) permissions
      [ROLES.COMMERCIAL_BANKING]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => false,
      },
    },
    [STATUS.APPROVED_BY_DEPT_HEAD]: {
      user: {
        view: (creator) => creator,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: (creator) => creator,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => true,
      },
      [ROLES.DIRECTOR]: {
        view: () => true,
        update: () => true,
        reject: () => true,
        request: () => false,
        approve: () => true,
        viewAmountDetails: () => true,
      },
      // F/A (Commercial Banking) permissions
      [ROLES.COMMERCIAL_BANKING]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => false,
      },
    },
    // IOU rejected (generic); F/A has no permissions regardless of who rejected
    [STATUS.REJECTED]: {
      user: {
        view: (creator) => creator,
        update: (creator) => creator,
        reject: () => false,
        request: (creator) => creator,
        approve: () => false,
        viewAmountDetails: (creator) => creator,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => true,
      },
      [ROLES.DIRECTOR]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => true,
      },
      [ROLES.COMMERCIAL_BANKING]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => false,
      },
    },
    [STATUS.APPROVED_BY_F_N_A]: {
      user: {
        view: (creator) => creator,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: (creator) => creator,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => true,
      },
      [ROLES.DIRECTOR]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => true,
      },
      [ROLES.ACCOUNTS]: {
        view: () => accountApprove,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => accountApprove,
      },
      // F/A (Commercial Banking) permissions for "Approved by F/A"
      [ROLES.COMMERCIAL_BANKING]: {
        view: () => true,
        update: () => true,
        reject: () => true,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => true,
      },
    },
    [STATUS.APPROVED_BY_DIRECTOR]: {
      user: {
        view: (creator) => creator,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: (creator) => creator,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => true,
      },
      [ROLES.DIRECTOR]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => true,
      },
      [ROLES.ACCOUNTS]: {
        view: () => true,
        update: () => true,
        reject: () => true,
        request: () => false,
        approve: () => true,
        viewAmountDetails: () => true,
      },
      // F/A (Commercial Banking) permissions for "Approved by Director"
      [ROLES.COMMERCIAL_BANKING]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
        viewAmountDetails: () => true,
      },
    },
  };

  if (departmentApprove === "approved") {
    permissions[STATUS.REJECTED][ROLES.DEPARTMENT_HEAD] = {
      view: () => true,
      update: () => false,
      reject: () => false,
    };
    permissions[STATUS.REJECTED][ROLES.DIRECTOR] = {
      view: () => true,
      update: () => true,
    };
  } else if (departmentApprove === "rejected") {
    permissions[STATUS.REJECTED][ROLES.DEPARTMENT_HEAD] = {
      view: () => true,
      update: () => false,
      reject: () => false,
    };
    permissions[STATUS.REJECTED][ROLES.DIRECTOR] = {
      view: () => false,
      update: () => false,
    };
  }

  if (departmentApprove === "approved") {
    permissions[STATUS.REJECTED][ROLES.DEPARTMENT_HEAD] = {
      ...permissions[STATUS.REJECTED][ROLES.DEPARTMENT_HEAD],
      view: () => true,
      update: () => false,
      reject: () => false,
      viewAmountDetails: () => true,
    };
    permissions[STATUS.REJECTED][ROLES.DIRECTOR] = {
      ...permissions[STATUS.REJECTED][ROLES.DIRECTOR],
      view: () => true,
      update: () => true,
      viewAmountDetails: () => true,
    };
  } else if (departmentApprove === "rejected") {
    permissions[STATUS.REJECTED][ROLES.DEPARTMENT_HEAD] = {
      ...permissions[STATUS.REJECTED][ROLES.DEPARTMENT_HEAD],
      view: () => true,
      update: () => false,
      reject: () => false,
      viewAmountDetails: () => true,
    };
    permissions[STATUS.REJECTED][ROLES.DIRECTOR] = {
      ...permissions[STATUS.REJECTED][ROLES.DIRECTOR],
      view: () => false,
      update: () => false,
      viewAmountDetails: () => true,
    };
  }

  if (directorApprove === "approved") {
    permissions[STATUS.REJECTED][ROLES.DIRECTOR] = {
      ...permissions[STATUS.REJECTED][ROLES.DIRECTOR],
      view: () => true,
      update: () => false,
      viewAmountDetails: () => true,
    };
  } else if (directorApprove === "rejected") {
    permissions[STATUS.REJECTED][ROLES.DIRECTOR] = {
      ...permissions[STATUS.REJECTED][ROLES.DIRECTOR],
      view: () => true,
      update: () => false,
      viewAmountDetails: () => true,
    };
  }

  if (accountApprove === "approved") {
    permissions[STATUS.REJECTED][ROLES.ACCOUNTS] = {
      ...permissions[STATUS.REJECTED][ROLES.ACCOUNTS],
      view: () => true,
      update: () => false,
      viewAmountDetails: () => true,
    };
  } else if (accountApprove === "rejected") {
    permissions[STATUS.REJECTED][ROLES.ACCOUNTS] = {
      ...permissions[STATUS.REJECTED][ROLES.ACCOUNTS],
      view: () => true,
      update: () => false,
      viewAmountDetails: () => true,
    };
  }

  const statusPerms = permissions[iouStatus];
  if (!statusPerms) return false;

  const rolePerms = statusPerms[userRole] || statusPerms["user"];
  if (!rolePerms) return false;

  const actionPerm = rolePerms[action];
  if (!actionPerm) return false;

  return actionPerm(isCreator);
};
